import { render, staticRenderFns } from "./InfiniteLoader.vue?vue&type=template&id=5f707b0c&scoped=true"
import script from "./InfiniteLoader.vue?vue&type=script&lang=js"
export * from "./InfiniteLoader.vue?vue&type=script&lang=js"
import style0 from "./InfiniteLoader.vue?vue&type=style&index=0&id=5f707b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f707b0c",
  null
  
)

export default component.exports